import React from 'react';
import { Spinner } from 'react-bootstrap';
import Select from 'react-select';

// options creator
const createOptions = (data) => {
  let options = [];
  data.forEach((x) => {
    options.push({ value: x, label: x, name: x });
  });
  return options;
};

// value creator
const valueOptions = (data) => {
  let values = [];
  data.forEach((x) => {
    values.push(x.value);
  });
  return values;
};

const DropdownSelect = (props) => {
  const limit = props.limit || 0;
  const limit_condition = limit !== 0 && props.value.length >= limit;

  return (
    <>
      <Select
        isMulti
        defaultValue={createOptions(props.value)}
        menuPlacement='auto'
        options={limit_condition ? [] : props.options}
        closeMenuOnSelect={false}
        onChange={(e) => props.onChange(valueOptions(e))}
        loadingMessage={() => 'Finding...'}
        noOptionsMessage={() =>
          limit_condition ? 'Max limit achieved' : 'No options available'
        }
        placeholder={<div>{props.placeholder || 'Select...'}</div>}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
          LoadingIndicator: () => (
            <div style={{ margin: '0.5rem' }}>
              <Spinner animation='border' variant='primary' />
            </div>
          )
        }}
        classNamePrefix={props.customclass || false}
        className={props.customclass || false}
        theme={(theme) => ({
          ...theme,
          colors: {
            ...theme.colors,
            primary25: '#bf00cd57',
            primary50: '#bf00cd57'
          }
        })}
      />
    </>
  );
};

export default DropdownSelect;
